import { Component, OnInit, Inject } from '@angular/core';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { BackendApiService } from '../../../app/services/backend-api.service';
import * as moment from "moment-timezone";
import { utc } from "moment";
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
@Component({
  selector: 'app-site-maintenance',
  templateUrl: './site-maintenance.component.html',
  styleUrls: ['./site-maintenance.component.scss'],
  standalone: true,
  imports:[CommonModule,MatButtonModule]
})
export class SiteMaintenanceComponent implements OnInit {
  public site_Maintenance: string = BaseUrlConstantsService.siteMaintenanceApi;
  public currentTime: Date;
  public dialog_type: any;
  public maintenanceLogList: any =[];
  public logNotAvailable: boolean;
  public showEmptyError;
  constructor(
    public dialog: MatDialog,
    public service: BackendApiService,
    // public dialogRef: MatDialogRef<SiteMaintenanceComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: {},
  ) {
    this.utcTime();
  }
  utcTime() {

    setInterval(() => {
      this.currentTime = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }
  ngOnInit(): void {
    this.getMaintenanceList();
  }
  getMaintenanceList(){
    this.service.getData(this.site_Maintenance + "/" + "maintenance")
    .then(res => {
       let response = JSON.parse(JSON.stringify(res)).data;
       console.log(response,'res')
       if(response.status === 'success'){
          if(response.body.length != 0){
            this.showEmptyError = "";
            this.maintenanceLogList = response.body;

            for (let i = 0; i < this.maintenanceLogList.length; i++) {
              this.maintenanceLogList[i].start_date = moment.utc(this.maintenanceLogList[i].start_date).local().format('YYYY-MM-DD HH:mm:ss');

              // Convert end_date from UTC to local time
              this.maintenanceLogList[i].end_date = moment.utc(this.maintenanceLogList[i].end_date).local().format('YYYY-MM-DD HH:mm:ss');

              // Convert publish_date from UTC to local time
              this.maintenanceLogList[i].publish_date = moment.utc(this.maintenanceLogList[i].publish_date).local().format('YYYY-MM-DD HH:mm:ss');
              // let testDateUtc = moment.utc(this.maintenanceLogList[i].start_date);


              // let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
              //   `${this.maintenanceLogList[i].start_date}` );
              // this.maintenanceLogList[i].start_date = timeUpdatedAt;
              // let testDateend = moment.utc(this.maintenanceLogList[i].end_date);

              // let localDate1 = testDateend.local();
              // let timeUpdatedAt1 = new ConvertDatetimePipe().convertDateTime(
              //   `${this.maintenanceLogList[i].end_date}`);
              // this.maintenanceLogList[i].end_date = timeUpdatedAt1;

              // let testDatepublish = moment.utc(this.maintenanceLogList[i].publish_date);

              // let localDate2 = testDatepublish.local();
              // let timeUpdatedAt2 = new ConvertDatetimePipe().convertDateTime(
              //   `${this.maintenanceLogList[i].publish_date}`);
              // this.maintenanceLogList[i].publish_date = timeUpdatedAt2;


            }
            console.log(this.maintenanceLogList);
          }else{
            this.showEmptyError = "No maintenance log Available!";
          }
       }else{
          this.showEmptyError = "No maintenance log Available!";
       }
    });
  }
  openScheduleForm(){
    const openSchedule = this.dialog.open(DialogOverviewExampleDialogComponent,
      {
        width:"309px",
        height:"463px",
        disableClose:false,
        data:{
          status: "createLog",
          type: "siteSchedule"
        }
      }
    );
    openSchedule.afterClosed().subscribe(result => {
      console.log(result,'result');
      if(result ==='success'){
        this.getMaintenanceList();
      }else{

      }
    })
  }

  editScheduleLog(val){
    console.log(val,'val')
    const openSchedule = this.dialog.open(DialogOverviewExampleDialogComponent,
      {
        width:"309px",
        height:"560px",
        disableClose:false,
        data:{
          values: val,
          status: "editLog",
          type: "siteSchedule"
        }
      }
    );
    openSchedule.afterClosed().subscribe(result => {
      console.log(result,'result');
      if(result ==='success'){
        this.getMaintenanceList();
      }else{

      }
    })
  }
}
